import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-pagination-page-ui',
    templateUrl: './bb-pagination-page-ui.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbPaginationUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
